import { claritySessionHeaders } from './clarity.js';

export const http = {
  options: { emulateHTTP: false, emulateJSON: false },
  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'X-Requested-With': 'XMLHttpRequest'
    },
    get: {},
    post: {},
    put: {},
    patch: {},
    delete: {}
  },
  get: function(url, options) {
    return this.request('GET', url, null, options);
  },
  post: function(url, body, options) {
    return this.request('POST', url, body, options);
  },
  put: function(url, body, options) {
    return this.request('PUT', url, body, options);
  },
  patch: function(url, body, options) {
    return this.request('PATCH', url, body, options);
  },
  delete: function(url, body, options) {
    return this.request('DELETE', url, body, options);
  },
  request: function(method, url, body, options) {
    var self = this;
    var opts = options || {};
    var emulateHTTP = opts.emulateHTTP != null ? opts.emulateHTTP : self.options.emulateHTTP;
    var emulateJSON = opts.emulateJSON != null ? opts.emulateJSON : self.options.emulateJSON;
    // Merge headers: common + method-specific + per-request
    var headers = {};
    Object.assign(headers, self.headers.common, self.headers[method.toLowerCase()] || {});
    Object.assign(headers, claritySessionHeaders(url));
    if (opts.headers) Object.assign(headers, opts.headers);
    // Append params to URL if provided
    if (opts.params) {
      var query = '';
      for (var key in opts.params) {
        if (opts.params[key] == null) continue;
        if (Array.isArray(opts.params[key])) {
          opts.params[key].forEach(function(val) {
            if (val == null) return;
            query += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(val);
          });
        } else if (typeof opts.params[key] === 'object') {
          query += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(JSON.stringify(opts.params[key]));
        } else {
          query += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(opts.params[key]);
        }
      }
      if (query) {
        url += (url.indexOf('?') === -1 ? '?' : '&') + query.substring(1);
      }
    }
    var bodyData = body;
    if (bodyData != null) {
      if (emulateJSON && typeof bodyData === 'object' && !(bodyData instanceof FormData)) {
        // send as application/x-www-form-urlencoded
        var formBody = '';
        for (var prop in bodyData) {
          if (bodyData[prop] == null) continue;
          formBody += '&' + encodeURIComponent(prop) + '=' + encodeURIComponent(bodyData[prop]);
        }
        bodyData = formBody.substring(1);
        headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
      } else if (bodyData instanceof FormData) {
        // Let browser set Content-Type (multipart/form-data with boundary)
        delete headers['Content-Type'];
      } else if (typeof bodyData === 'object') {
        bodyData = JSON.stringify(bodyData);
        headers['Content-Type'] = 'application/json;charset=UTF-8';
      }
      // (If bodyData is a string or other primitive, leave as-is and assume appropriate Content-Type is set if needed)
    }
    if (emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(method)) {
      headers['X-HTTP-Method-Override'] = method;
      method = 'POST';
    }
    var fetchOptions = { method: method, headers: headers };
    if (bodyData != null && method !== 'GET' && method !== 'HEAD') {
      fetchOptions.body = bodyData;
    }
    if (opts.credentials) {
      fetchOptions.credentials = opts.credentials;
    }
    return fetch(url, fetchOptions).then(function(res) {
      // Check if responseType is blob or arraybuffer
      if (opts.responseType === 'blob') {
        return res.blob().then(function(blob) {
          var result = {
            ok: res.ok,
            status: res.status,
            statusText: res.statusText,
            url: res.url,
            headers: res.headers,
            body: blob,
            bodyText: null
          };
          return res.ok ? result : Promise.reject(result);
        });
      } else if (opts.responseType === 'arraybuffer') {
        return res.arrayBuffer().then(function(arrayBuffer) {
          var result = {
            ok: res.ok,
            status: res.status,
            statusText: res.statusText,
            url: res.url,
            headers: res.headers,
            body: arrayBuffer,
            bodyText: null
          };
          return res.ok ? result : Promise.reject(result);
        });
      } else {
        return res.text().then(function(text) {
          var result = {
            ok: res.ok,
            status: res.status,
            statusText: res.statusText,
            url: res.url,
            headers: res.headers,
            bodyText: text
          };
          var contentType = res.headers.get('Content-Type') || '';
          if (contentType.toLowerCase().includes('json')) {
            try {
              result.body = JSON.parse(text);
            } catch (e) {
              result.body = text;
            }
          } else {
            result.body = text;
          }
          return res.ok ? result : Promise.reject(result);
        });
      }
    }).catch(function(err) {
      // If this is already a response object
      if (err && typeof err === 'object' && 'status' in err && 'ok' in err) {
        return Promise.reject(err);
      }
      // Otherwise, this is a network error
      return Promise.reject({
        ok: false,
        status: 0,
        statusText: '',
        url: url,
        headers: new Headers(),
        body: null,
        bodyText: (err && err.message) ? err.message : String(err)
      });
    });
  }
};
